// src/features/simulators/mobile-kiosk/types/index.ts

import {
  SectionCode,
  JourneyEventCode,
  KeyDeliveryMethod,
  GuestType,
} from '@/features/simulators/shared/types/journey.types';

// Re-export shared types
export { SectionCode, JourneyEventCode, KeyDeliveryMethod, GuestType };

// Mobile kiosk specific constants
export const MOBILE_KIOSK_SECTIONS = [
  SectionCode.S,
  SectionCode.I,
  SectionCode.F,
  SectionCode.U,
  SectionCode.P,
  SectionCode.K,
] as const;

export const MOBILE_KIOSK_CHANNEL = 'MobileKiosk';
export const PHYSICAL_KIOSK_CHANNEL = 'Kiosk';

// DeviceType for both mobile and physical is the same or 'Mobile'/'Kiosk'
export const MOBILE_KIOSK_DEVICE_TYPE = 'Mobile';
export const PHYSICAL_KIOSK_DEVICE_TYPE = 'Kiosk';

/**
 * Terminal type for Mobile Kiosk
 */
export enum TerminalType {
  MOBILE = 'Mobile',          // Guest's own mobile device
  PHYSICAL = 'Physical',      // Physical kiosk running MobileKiosk app
}

/**
 * Configuration for mobile kiosk simulator
 */
export interface MobileKioskConfig {
  hotelId: string;
  deviceId: string;
  terminalType: TerminalType;
  count: number;
  delayBetweenSteps: number;
  delayBetweenCheckIns: number;
  guestType: GuestType;                    // Changed from checkInType
  keyDeliveryMethod: KeyDeliveryMethod;    // Unified key delivery method
  errorRate: number;
  abandonmentRate: number;
  reservationNumber?: string;              // Optional manual reservation number
  autoGenerateReservation?: boolean;       // Auto-generate or manual entry
}

/**
 * Statistics for mobile kiosk simulator
 */
export interface MobileKioskStats {
  totalCheckIns: number;
  successfulCheckIns: number;
  failedCheckIns: number;
  abandonedCheckIns: number;
  walkingCheckIns: number;
  reservationCheckIns: number;
  totalEvents: number;
  averageTime: number;
  
  // Key delivery
  keysDelivered: number;
  keyDeliveryErrors: number;
  
  // Terminal type breakdown
  fromMobileTerminal: number;
  fromPhysicalTerminal: number;
  
  // Key type breakdown
  digitalKeysDelivered: number;
  physicalKeysDispensed: number;
  qrGenerated: number;
  
  startTime?: Date;
  endTime?: Date;
}

/**
 * Result of a single check-in session
 */
export interface MobileKioskResult {
  success: boolean;
  reservationNumber: string;
  duration: number;
  error?: string;
  keyDelivered: boolean;
}